import { useState } from 'react';
import { loginAdmin } from '../services/authService';
import './AdminLogin.css';

interface AdminLoginProps {
  onLoginSuccess: () => void;
}

export const AdminLogin = ({ onLoginSuccess }: AdminLoginProps) => {
  const [key, setKey] = useState('');
  const [error, setError] = useState('');
  const [attemptsLeft, setAttemptsLeft] = useState<number | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setAttemptsLeft(null);
    setIsLoading(true);

    const result = await loginAdmin(key);

    if (result.success) {
      onLoginSuccess();
    } else {
      setError(result.error || 'Ошибка входа');
      if (result.attemptsLeft !== undefined) {
        setAttemptsLeft(result.attemptsLeft);
      }
    }

    setIsLoading(false);
  };

  return (
    <div className="admin-login">
      <div className="admin-login-container">
        <h2 className="admin-login-title">🔐 Вход в админ-панель</h2>
        <form onSubmit={handleSubmit} className="admin-login-form">
          <div className="admin-login-field">
            <label htmlFor="admin-key">Ключ доступа:</label>
            <input
              id="admin-key"
              type="password"
              value={key}
              onChange={(e) => setKey(e.target.value)}
              placeholder="Введите ключ доступа"
              disabled={isLoading}
              autoFocus
            />
          </div>
          
          {error && (
            <div className="admin-login-error">
              {error}
              {attemptsLeft !== null && attemptsLeft > 0 && (
                <div className="admin-login-attempts">
                  Осталось попыток: {attemptsLeft}
                </div>
              )}
              {attemptsLeft === 0 && (
                <div className="admin-login-blocked">
                  IP заблокирован. Попробуйте позже.
                </div>
              )}
            </div>
          )}

          <button 
            type="submit" 
            className="admin-login-button"
            disabled={isLoading || !key.trim()}
          >
            {isLoading ? 'Вход...' : 'Войти'}
          </button>
        </form>
      </div>
    </div>
  );
};

